import { createSlice } from "@reduxjs/toolkit";
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

let webApiUrl = `${process.env.REACT_APP_BASE_URL}sound_3minutes`;
let tokenStr = process.env.REACT_APP_API_TOKEN;

export const fetchSound = createAsyncThunk("sound/fetchSound", () => {
  return axios
    .get(webApiUrl, { headers: { Authorization: `Token ${tokenStr}` } })
    .then((response) => response.data);
});
const soundSlice = createSlice({
  name: "sound",
  initialState: {
    soundLoading: true,
    soundData: {
      OSPL: [],
      SATA: [],
    },
    soundError: "",
  },
  extraReducers: (builder) => {
    builder.addCase(
      fetchSound.pending,
      (state) => {
        state.soundLoading = true;
      },
      builder.addCase(
        fetchSound.fulfilled,
        (state, action) => {
          state.soundLoading = false;
          state.soundData = action.payload;
          state.soundError = "";
        },
        builder.addCase(fetchSound.rejected, (state, action) => {
          state.soundLoading = false;
          state.soundData = [];
          state.soundError = action.error.message;
        })
      )
    );
  },
});
export default soundSlice.reducer;
